<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="UploadInvoiceLines"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpAlert
      variant="info"
      show
    >
      <p>
        <ItpIcon
          fa="info-circle"
        >
        </ItpIcon>
        <ItpText
          wrap
        >
          Számlasorok a következő sablon kitöltésével tölthetők fel:

        </ItpText>
        <ItpLink
          :text="'Download template'|pgettext('UploadInvoiceLines')"
          :href="downloadTemplateURL"
          button
          variant="light"
          use-auth
          force-download
        >
        </ItpLink>
      </p>
    </ItpAlert>
    <hr>
    </hr>
    <DIV
      class="container"
    >
      <ItpForm
        :name="formName"
        :id="formId"
        v-if="loaded"
        @submit="evh_648747096704084_submit($event, {})"
      >
        <ItpFormGroup
          name="file"
          :label="'Invoice lines file'|pgettext('UploadInvoiceLines')"
          labelFor="file"
          :description="'Please select a filled-in template file.'|pgettext('UploadInvoiceLines')"
          required
        >
          <ItpFormFile
            v-model="file"
            name="file"
            accept=".xlsx"
            required
            :validation="b_3086171180629160_validation"
          >
          </ItpFormFile>
        </ItpFormGroup>
      </ItpForm>
      <ItpAlert
        :show="resultText && !actions.submit.isRunning"
      >
        <p>
          {{ resultText }}
        </p>
      </ItpAlert>
    </DIV>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :form="formId"
      :text="'Upload lines'|pgettext('UploadInvoiceLines')"
      type="submit"
      variant="primary"
      icon="fa-file-import"
      :spinning="actions.submit.isRunning"
      :disabled="!forms[formName] || !forms[formName].submittable"
    >
    </ItpButton>
    <ItpButton
      :text="'Cancel'|gettext"
      variant="default"
      :disabled="actions.submit.isRunning"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UploadInvoiceLines extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  file!: any;
  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  formName!: any;
  resultText!: any;
  downloadTemplateURL!: any;

  async $$load_downloadTemplateURL() {
    return this.$fn.urlFor('download_file_template_invoice_lines_upload')
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_3086171180629160_validation!: any;
  dataMembers = ['file', 'formId', 'formName', 'resultText', 'downloadTemplateURL', 'ux', 'b_7315092382398562_modalBindings', 'b_3086171180629160_validation'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        file: null,
        formId: null,
        formName: "UploadInvoiceLines",
        resultText: null,
        downloadTemplateURL: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "md",
        }
        ,
        b_3086171180629160_validation: ["ext:xlsx"
          ,
          "required"
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.pgettext("UploadInvoiceLines|Title", "Upload invoice lines"),
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_9164_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_9164, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_648747096704084_register_9170_getActionArgs($event: actions.ActionEvent): Promise<actions.RegisterActionArgs> {
    // parameterResolver name=act_648747096704084_register_9170, alias=undefined
    return {
      name: "resultLength",
      value: $event.data.response.data ? $event.data.response.data.length : 0,
    }
  }

  async act_648747096704084_setData_9172_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_648747096704084_setData_9172, alias=undefined
    return {
      path: "resultText",
      value: this.$fn.ngettext("One line has been imported.", "${n} lines have been imported.", this.resultLength),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_648747096704084_success_9171_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_648747096704084_success_9171, alias=undefined
    return $event.data.resultLength > 0
  }

  async act_648747096704084_setData_9174_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_648747096704084_setData_9174, alias=undefined
    return {
      path: "resultText",
      value: this.$fn.gettext("No lines have been imported."),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_648747096704084_success_9173_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_648747096704084_success_9173, alias=undefined
    return !$event.data.resultLength
  }

  async act_648747096704084_request_9168_getActionArgs($event: actions.ActionEvent): Promise<actions.RequestActionArgs> {
    // parameterResolver name=act_648747096704084_request_9168, alias=submit
    return {
      operation: "upload_invoice_lines",
      data: { file: this.file },
      parameters: {
        invoice_id: this.invoice.id,
      }
      ,
      contentType: "multipart/form-data",
    }
  }

  async evh_648747096704084_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_648747096704084_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_9176_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_9176, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_9164: actions.CloseModalAction;
    evh_7315092382398562_close_9163: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeComponent_9166: actions.CloseComponentAction;
    evh_2248226175642056_close_9165: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_648747096704084_register_9170: actions.RegisterAction;
    evh_648747096704084_success_9169: actions.EventHandlerImpl;
    act_648747096704084_setData_9172: actions.SetDataAction;
    evh_648747096704084_success_9171: actions.EventHandlerImpl;
    act_648747096704084_setData_9174: actions.SetDataAction;
    evh_648747096704084_success_9173: actions.EventHandlerImpl;
    act_648747096704084_request_9168: actions.RequestAction;
    evh_648747096704084_submit_9167: actions.EventHandlerImpl;
    evh_648747096704084_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_9176: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_9175: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_9164 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_9164_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_9163 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_9164,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_9163],
      }
    );
    const act_2248226175642056_closeComponent_9166 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_9165 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeComponent_9166,
        event: "close",
        displayName: "closeComponent",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_9165],
      }
    );
    const act_648747096704084_register_9170 = new actions.RegisterAction(
      {
        actionArgs: this.act_648747096704084_register_9170_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9169 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_register_9170,
        event: "success",
        displayName: "register",
      }
    );
    const act_648747096704084_setData_9172 = new actions.SetDataAction(
      {
        actionArgs: this.act_648747096704084_setData_9172_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9171 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_setData_9172,
        event: "success",
        when: this.evh_648747096704084_success_9171_getWhen,
        displayName: "setData",
      }
    );
    const act_648747096704084_setData_9174 = new actions.SetDataAction(
      {
        actionArgs: this.act_648747096704084_setData_9174_getActionArgs,
        events: [],
      }
    );
    const evh_648747096704084_success_9173 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_setData_9174,
        event: "success",
        when: this.evh_648747096704084_success_9173_getWhen,
        displayName: "setData",
      }
    );
    const act_648747096704084_request_9168 = new actions.RequestAction(
      {
        actionArgs: this.act_648747096704084_request_9168_getActionArgs,
        displayName: "submit",
        events: [evh_648747096704084_success_9169, evh_648747096704084_success_9171, evh_648747096704084_success_9173],
      }
    );
    const evh_648747096704084_submit_9167 = new actions.EventHandlerImpl(
      {
        action: act_648747096704084_request_9168,
        event: "submit",
        displayName: "submit",
      }
    );
    const evh_648747096704084_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_648747096704084_submit_9167],
      }
    );
    const act_1419464017721962_closeModal_9176 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_9176_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_9175 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_9176,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_9175],
      }
    );
    return {
      act_7315092382398562_closeModal_9164,
      evh_7315092382398562_close_9163,
      evh_7315092382398562_close,
      act_2248226175642056_closeComponent_9166,
      evh_2248226175642056_close_9165,
      evh_2248226175642056_close,
      act_648747096704084_register_9170,
      evh_648747096704084_success_9169,
      act_648747096704084_setData_9172,
      evh_648747096704084_success_9171,
      act_648747096704084_setData_9174,
      evh_648747096704084_success_9173,
      act_648747096704084_request_9168,
      evh_648747096704084_submit_9167,
      evh_648747096704084_submit,
      act_1419464017721962_closeModal_9176,
      evh_1419464017721962_clickPreventStop_9175,
      evh_1419464017721962_clickPreventStop,
      submit: act_648747096704084_request_9168,
    }
  }
}

Vue.component("UploadInvoiceLines", UploadInvoiceLines);

</script>